import {
  CHANGE_BUSINESS_FILTER,
  GETTING_ALL_BUSINESS,
  GET_ALL_BUSINESS,
  GET_ALL_BUSINESS_SUCCESS,
  OPEN_BUSINESS_DETAILS,
  CLOSE_BUSINESS_DETAILS,
  SET_ACTIVE_BUSINESS_DETAILS,
  SET_BUSINESS_MENU_ITEM,
  GETTING_EMPLOYEE_SLOTS_LOGS,
  GETTING_EMPLOYEE_SLOTS,
  GETTING_BUSINESS_DETAILS,
  GET_BUSINESS_DETAILS,
  GET_EMPLOYEE_SLOTS_LOGS,
  GET_EMPLOYEE_SLOTS,
  CREATE_EMPLOYEE_SLOT,
  UPDATE_EMPLOYEE_SLOT_IS_RENEWABLE_STATUS,
  GET_EMPLOYEE_SLOTS_LOGS_SUCCESS,
  GET_EMPLOYEE_SLOTS_SUCCESS,
  GET_BUSINESS_DETAILS_SUCCESS,
  CREATING_EMPLOYEE_SLOT,
  UPDATING_EMPLOYEE_SLOT_IS_RENEWABLE_STATUS,
  GET_PURCHASED_EMPLOYEE_SLOTS_SUCCESS,
  SET_EMPLOYEE_MENU_ITEM,
  SET_EMPLOYEE_SLOTS_PAGE,
  SET_EMPLOYEE_ACTIONS_PAGE,
  OPEN_CREATE_EMPLOYEE_SLOT_MODAL,
  CLOSE_CREATE_EMPLOYEE_SLOT_MODAL,
  SET_BUSINESS_DETAIL_MENU_ITEM,
  UPDATE_BUSINESS_PACKAGE,
  UPDATING_BUSINESS_PACKAGE,
  OPEN_UPDATE_RENEWAL_STATUS_MODAL,
  CLOSE_UPDATE_RENEWAL_STATUS_MODAL,
  SET_SELECTED_UPDATE_RENEWAL_STATUS_INDEX,
  OPEN_UPDATE_BUSINESS_PACKAGE_MODAL,
  CLOSE_UPDATE_BUSINESS_PACKAGE_MODAL,
  SET_SELECTED_BUSINESS_PACKAGE,
  GET_GOBIZ_LINKING,
  GETTING_GOBIZ_LINKING,
  GET_GOBIZ_LINKING_SUCCESS,
  SET_LINKING_MENU_ITEM,
  GET_OUTLETS,
  GET_OUTLETS_SUCCESS,
  ADD_OUTLET_SLOT,
  GET_DEVICE_LOGS,
  GET_DEVICE_LOGS_SUCCESS,
  LOADING_OUTLETS,
  GET_BILLING_HISTORY,
  GET_BILLING_HISTORY_SUCCESS,
  UPDATE_OUTLET_SUBSCRIPTIONS,
  GET_FEATURE_SUBSCRIPTIONS,
  GET_FEATURE_SUBSCRIPTIONS_SUCCESS,
  ACTIVATE_FEATURE_SUBSCRIPTIONS_OUTLET,
  GET_OUTLET_SLOTS,
  GET_OUTLET_SLOTS_SUCCESS,
  UPDATE_OUTLETS_SLOTS,
  GET_OUTLET_LOGS,
  GET_OUTLET_LOGS_SUCCESS,
  LOADING_OUTLET_LOGS,
  UPDATE_OUTLET_SUBSCRIPTIONS_UI,
  GETTING_RECURRING_PAYMENTS_DETAILS,
  GET_RECURRING_PAYMENTS_DETAILS_SUCCESS,
  GET_RECURRING_PAYMENTS_DETAILS,
  CANCEL_RECURRING_PAYMENT,
  CANCELLING_RECURRING_PAYMENT,
  SHOW_CANCEL_RECURRING_PAYMENT_CONFIRMATION,
  CLOSE_CANCEL_RECURRING_PAYMENT_CONFIRMATION,
  GET_RECURRING_PAYMENT_TRANSACTIONS,
  GET_RECURRING_PAYMENT_TRANSACTIONS_SUCCESS,
  GET_RECURRING_PAYMENT_HISTORY,
  GET_RECURRING_PAYMENT_HISTORY_SUCCESS,
  OPEN_UPDATE_OWNER_PHONE_MODAL,
  CLOSE_UPDATE_OWNER_PHONE_MODAL,
  SET_OWNER_PHONE_INPUT,
  SET_OWNER_PHONE_ERROR,
  UPDATE_OWNER_PHONE,
  UPDATING_OWNER_PHONE,
  VOID_INVOICE,
  OPEN_INVOICE_FILE,
  VOIDING_INVOICE,
  SHOW_VOID_INVOICE_CONFIRMATION,
  CLOSE_VOID_INVOICE_CONFIRMATION,
  GET_INVOICE_VOID_LOGS,
  GET_INVOICE_VOID_LOGS_SUCCESS,
  LOADING_INVOICE_VOID_LOGS,
  OPEN_INVOICE_VOID_LOG_MODAL,
  CLOSE_INVOICE_VOID_LOG_MODAL,
  OPEN_UPDATE_BUSINESS_ENTITY_MODAL,
  CLOSE_UPDATE_BUSINESS_ENTITY_MODAL,
  SET_BUSINESS_ENTITY_TYPE_INPUT,
  SET_BUSINESS_ENTITY_TYPE_ERROR,
  UPDATE_BUSINESS_ENTITY_TYPE,
  UPDATING_BUSINESS_ENTITY_TYPE,
} from 'state/actionTypes';

export const getAllBusiness = payload => {
  return {
    type: GET_ALL_BUSINESS,
    payload,
  };
};

export const setActiveBusinessDetails = payload => {
  return {
    type: SET_ACTIVE_BUSINESS_DETAILS,
    payload,
  };
};

export const changeBusinessFilter = filter => ({
  type: CHANGE_BUSINESS_FILTER,
  payload: filter,
});

export const getAllBusinessSuccess = payload => {
  return {
    type: GET_ALL_BUSINESS_SUCCESS,
    payload,
  };
};

export const gettingAllBusiness = payload => {
  return {
    type: GETTING_ALL_BUSINESS,
    payload,
  };
};

export const openBusinessDetails = () => ({
  type: OPEN_BUSINESS_DETAILS,
});

export const closeBusinessDetails = () => ({
  type: CLOSE_BUSINESS_DETAILS,
});

export const setBusinessMenuItem = payload => {
  return {
    type: SET_BUSINESS_MENU_ITEM,
    payload,
  };
};

export const gettingEmployeeSlotsLogs = payload => {
  return {
    type: GETTING_EMPLOYEE_SLOTS_LOGS,
    payload,
  };
};

export const gettingEmployeeSlots = payload => {
  return {
    type: GETTING_EMPLOYEE_SLOTS,
    payload,
  };
};

export const gettingBusinessDetails = payload => {
  return {
    type: GETTING_BUSINESS_DETAILS,
    payload,
  };
};

export const creatingEmployeeSlot = payload => {
  return {
    type: CREATING_EMPLOYEE_SLOT,
    payload,
  };
};

export const updatingEmployeeSlotIsRenewableStatus = payload => {
  return {
    type: UPDATING_EMPLOYEE_SLOT_IS_RENEWABLE_STATUS,
    payload,
  };
};

export const getEmployeeSlotsLogs = payload => {
  return {
    type: GET_EMPLOYEE_SLOTS_LOGS,
    payload,
  };
};

export const getEmployeeSlots = payload => {
  return {
    type: GET_EMPLOYEE_SLOTS,
    payload,
  };
};

export const getBusinessDetails = payload => {
  return {
    type: GET_BUSINESS_DETAILS,
    payload,
  };
};

export const createEmployeeSlot = payload => {
  return {
    type: CREATE_EMPLOYEE_SLOT,
    payload,
  };
};

export const updateEmployeeSlotIsRenewableStatus = payload => {
  return {
    type: UPDATE_EMPLOYEE_SLOT_IS_RENEWABLE_STATUS,
    payload,
  };
};

export const getEmployeeSlotsLogsSuccess = payload => {
  return {
    type: GET_EMPLOYEE_SLOTS_LOGS_SUCCESS,
    payload,
  };
};

export const getEmployeeSlotsSuccess = payload => {
  return {
    type: GET_EMPLOYEE_SLOTS_SUCCESS,
    payload,
  };
};

export const getPurchasedEmployeeSlotsSuccess = payload => {
  return {
    type: GET_PURCHASED_EMPLOYEE_SLOTS_SUCCESS,
    payload,
  };
};

export const getBusinessDetailsSuccess = payload => {
  return {
    type: GET_BUSINESS_DETAILS_SUCCESS,
    payload,
  };
};

export const setEmployeeMenuItem = payload => {
  return {
    type: SET_EMPLOYEE_MENU_ITEM,
    payload,
  };
};

export const setEmployeeSlotsPage = payload => {
  return {
    type: SET_EMPLOYEE_SLOTS_PAGE,
    payload,
  };
};

export const setEmployeeActionsPage = payload => {
  return {
    type: SET_EMPLOYEE_ACTIONS_PAGE,
    payload,
  };
};

export const setBusinessDetailMenuItem = payload => {
  return {
    type: SET_BUSINESS_DETAIL_MENU_ITEM,
    payload,
  };
};

export const openCreateEmployeeSlotModal = () => ({
  type: OPEN_CREATE_EMPLOYEE_SLOT_MODAL,
});

export const closeCreateEmployeeSlotModal = () => ({
  type: CLOSE_CREATE_EMPLOYEE_SLOT_MODAL,
});

export const updateBusinessPackage = payload => {
  return {
    type: UPDATE_BUSINESS_PACKAGE,
    payload,
  };
};

export const updatingBusinessPackage = payload => {
  return {
    type: UPDATING_BUSINESS_PACKAGE,
    payload,
  };
};

export const openUpdateRenewalStatusModal = () => ({
  type: OPEN_UPDATE_RENEWAL_STATUS_MODAL,
});

export const closeUpdateRenewalStatusModal = () => ({
  type: CLOSE_UPDATE_RENEWAL_STATUS_MODAL,
});

export const setSelectedUpdateRenewalStatusIndex = payload => {
  return {
    type: SET_SELECTED_UPDATE_RENEWAL_STATUS_INDEX,
    payload,
  };
};

export const openUpdateBusinessPackageModal = () => ({
  type: OPEN_UPDATE_BUSINESS_PACKAGE_MODAL,
});

export const closeUpdateBusinessPackageModal = () => ({
  type: CLOSE_UPDATE_BUSINESS_PACKAGE_MODAL,
});

export const setSelectedBusinessPackage = payload => {
  return {
    type: SET_SELECTED_BUSINESS_PACKAGE,
    payload,
  };
};

export const getGoBizLinking = payload => {
  return {
    type: GET_GOBIZ_LINKING,
    payload,
  };
};

export const gettingGoBizLinking = payload => {
  return {
    type: GETTING_GOBIZ_LINKING,
    payload,
  };
};

export const getGoBizLinkingSuccess = payload => {
  return {
    type: GET_GOBIZ_LINKING_SUCCESS,
    payload,
  };
};

export const setLinkingMenuItem = payload => {
  return {
    type: SET_LINKING_MENU_ITEM,
    payload,
  };
};

export const getOutletsAction = payload => {
  return {
    type: GET_OUTLETS,
    payload,
  };
};

export const loadingOutletsAction = payload => {
  return {
    type: LOADING_OUTLETS,
    payload,
  };
};

export const getOutletsSuccessAction = payload => {
  return {
    type: GET_OUTLETS_SUCCESS,
    payload,
  };
};

export const addOutletSlotAction = payload => {
  return {
    type: ADD_OUTLET_SLOT,
    payload,
  };
};

export const getDeviceLogsAction = payload => {
  return {
    type: GET_DEVICE_LOGS,
    payload,
  };
};

export const getDeviceLogsSuccessAction = payload => {
  return {
    type: GET_DEVICE_LOGS_SUCCESS,
    payload,
  };
};

export const getBillingHistoryAction = payload => {
  return {
    type: GET_BILLING_HISTORY,
    payload,
  };
};

export const getBillingHistorySuccessAction = payload => {
  return {
    type: GET_BILLING_HISTORY_SUCCESS,
    payload,
  };
};

export const updateOutletSubcriptionsAction = payload => {
  return {
    type: UPDATE_OUTLET_SUBSCRIPTIONS,
    payload,
  };
};

export const getFeatureSubscriptionsAction = payload => {
  return {
    type: GET_FEATURE_SUBSCRIPTIONS,
    payload,
  };
};

export const getFeatureSubscriptionsSuccessAction = payload => {
  return {
    type: GET_FEATURE_SUBSCRIPTIONS_SUCCESS,
    payload,
  };
};

export const activateFeatureSubscriptionsOutletAction = payload => {
  return {
    type: ACTIVATE_FEATURE_SUBSCRIPTIONS_OUTLET,
    payload,
  };
};

export const getOutletSlotsAction = payload => {
  return {
    type: GET_OUTLET_SLOTS,
    payload,
  };
};

export const getOutletSlotsSuccessAction = payload => {
  return {
    type: GET_OUTLET_SLOTS_SUCCESS,
    payload,
  };
};

export const updateOutletsSlotsAction = payload => {
  return {
    type: UPDATE_OUTLETS_SLOTS,
    payload,
  };
};

export const getOutletLogsAction = payload => {
  return {
    type: GET_OUTLET_LOGS,
    payload,
  };
};

export const loadingOutletLogsAction = payload => {
  return {
    type: LOADING_OUTLET_LOGS,
    payload,
  };
};

export const getOutletLogsSuccessAction = payload => {
  return {
    type: GET_OUTLET_LOGS_SUCCESS,
    payload,
  };
};

export const updateOutletSubscriptionUIAction = payload => {
  return {
    type: UPDATE_OUTLET_SUBSCRIPTIONS_UI,
    payload,
  };
};

export const getRecurringPaymentsDetails = payload => {
  return {
    type: GET_RECURRING_PAYMENTS_DETAILS,
    payload,
  };
};

export const gettingRecurringPaymentsDetails = payload => {
  return {
    type: GETTING_RECURRING_PAYMENTS_DETAILS,
    payload,
  };
};

export const getRecurringPaymentsDetailsSuccess = payload => {
  return {
    type: GET_RECURRING_PAYMENTS_DETAILS_SUCCESS,
    payload,
  };
};

export const showCancelRecurringPaymentConfirmation = () => ({
  type: SHOW_CANCEL_RECURRING_PAYMENT_CONFIRMATION,
});

export const closeCancelRecurringPaymentConfirmation = () => ({
  type: CLOSE_CANCEL_RECURRING_PAYMENT_CONFIRMATION,
});

export const cancelRecurringPayment = (businessId, onSuccess) => {
  return {
    type: CANCEL_RECURRING_PAYMENT,
    payload: {
      businessId,
      onSuccess,
    },
  };
};

export const cancellingRecurringPayment = payload => {
  return {
    type: CANCELLING_RECURRING_PAYMENT,
    payload,
  };
};

export const getRecurringPaymentHistoryAction = payload => {
  return {
    type: GET_RECURRING_PAYMENT_HISTORY,
    payload,
  };
};

export const getRecurringPaymentHistorySuccessAction = payload => {
  return {
    type: GET_RECURRING_PAYMENT_HISTORY_SUCCESS,
    payload,
  };
};

export const getRecurringPaymentTransactionsAction = payload => {
  return {
    type: GET_RECURRING_PAYMENT_TRANSACTIONS,
    payload,
  };
};

export const getRecurringPaymentTransactionSuccessAction = payload => {
  return {
    type: GET_RECURRING_PAYMENT_TRANSACTIONS_SUCCESS,
    payload,
  };
};

export const openUpdateOwnerPhoneModal = () => ({
  type: OPEN_UPDATE_OWNER_PHONE_MODAL,
});

export const closeUpdateOwnerPhoneModal = () => ({
  type: CLOSE_UPDATE_OWNER_PHONE_MODAL,
});

export const setOwnerPhoneInput = payload => {
  return {
    type: SET_OWNER_PHONE_INPUT,
    payload,
  };
};

export const voidInvoiceAction = payload => {
  return {
    type: VOID_INVOICE,
    payload,
  };
};

export const openInvoiceFileAction = payload => {
  return {
    type: OPEN_INVOICE_FILE,
    payload,
  };
};

export const voidingInvoiceAction = payload => {
  return {
    type: VOIDING_INVOICE,
    payload,
  };
};

export const showVoidInvoiceConfirmation = () => ({
  type: SHOW_VOID_INVOICE_CONFIRMATION,
});

export const closeVoidInvoiceConfirmation = () => ({
  type: CLOSE_VOID_INVOICE_CONFIRMATION,
});

export const getInvoiceVoidLogsAction = payload => {
  return {
    type: GET_INVOICE_VOID_LOGS,
    payload,
  };
};

export const setOwnerPhoneError = payload => {
  return {
    type: SET_OWNER_PHONE_ERROR,
    payload,
  };
};
export const getInvoiceVoidLogsSuccessAction = payload => {
  return {
    type: GET_INVOICE_VOID_LOGS_SUCCESS,
    payload,
  };
};

export const updateOwnerPhone = payload => {
  return {
    type: UPDATE_OWNER_PHONE,
    payload,
  };
};

export const loadingInvoiceVoidLogsAction = payload => {
  return {
    type: LOADING_INVOICE_VOID_LOGS,
    payload,
  };
};

export const updatingOwnerPhone = payload => {
  return {
    type: UPDATING_OWNER_PHONE,
    payload,
  };
};

export const openInvoiceVoidLogModal = () => ({
  type: OPEN_INVOICE_VOID_LOG_MODAL,
});

export const closeInvoiceVoidLogModal = () => ({
  type: CLOSE_INVOICE_VOID_LOG_MODAL,
});

export const openUpdateBusinessEntityModal = () => ({
  type: OPEN_UPDATE_BUSINESS_ENTITY_MODAL,
});

export const closeUpdateBusinessEntityModal = () => ({
  type: CLOSE_UPDATE_BUSINESS_ENTITY_MODAL,
});

export const setBusinessEntityTypeInput = payload => {
  return {
    type: SET_BUSINESS_ENTITY_TYPE_INPUT,
    payload,
  };
};

export const setBusinessEntityTypeError = payload => {
  return {
    type: SET_BUSINESS_ENTITY_TYPE_ERROR,
    payload,
  };
};

export const updateBusinessEntityType = payload => {
  return {
    type: UPDATE_BUSINESS_ENTITY_TYPE,
    payload,
  };
};

export const updatingBusinessEntityType = payload => {
  return {
    type: UPDATING_BUSINESS_ENTITY_TYPE,
    payload,
  };
};
